<template>
  <div class="notice-list">
    <associationNotice @changePage="changePage" @click="toDetails" :list="notice" :total="noticeTotal" v-loading="loading"></associationNotice>
  </div>
</template>

<script>
import associationNotice from '@/components/associationNotice.vue'
import {mapMutations} from 'vuex'
import {findRoute} from '@/utils/routerHelper.js'
import {dynamics} from '@/api/api.js';
export default {
  components:{
    associationNotice
  },
  data(){
    return {
      loading:false,
      notice:[
        {
          title:'关于召开攀枝花东区社会工作协会2024年度会员代表大会的通知',
          date:'2025-12-15'
        },
        {
          title:'关于开展2024年度会员单位评优评先工作的通知',
          date:'2025-12-12'
        },
        {
          title:'关于举办会员专业技能提升培训班的通知',
          date:'2025-12-10'
        },
        {
          title:'关于组织会员参加社会工作主题沙龙活动的通知',
          date:'2025-12-08'
        },
        {
          title:'关于开展会员走访调研活动的通知',
          date:'2025-12-05'
        },
        {
          title:'关于召开会员座谈会的通知',
          date:'2025-12-03'
        },
        {
          title:'关于举办会员联谊活动的通知',
          date:'2025-12-01'
        },
        {
          title:'关于开展会员满意度调查的通知',
          date:'2025-11-28'
        },
      ],
      noticeTotal:0,
      currentPage:1
    }
  },
   created(){
    this.getList()
  },
  methods:{
    ...mapMutations('routerData',['changeRouterList']),
    getList(){
      dynamics({
        current:this.currentPage,
        size:10,
        type:17
      }).then(res=>{
        if(res.data.code==200){
          this.noticeTotal=res.data.data.total
          this.notice=res.data.data.records.map(v=>{
            let dateData=this.getDate(v.createTime)
            v.date=dateData.newDates,
            v.day=dateData.day
            return v
          })
        }
      })
    },
    toDetails(data){
      this.$router.push(
        { path: '/associationNews/details',query: { id: data.id } }
      )
      let routerList=[]
      let routers = ['/memberService','memberServiceMemberNotice', '/associationNews/details'];
      for (let i = 0; i < routers.length; i++) {
        let routerData=findRoute(this.$router.options.routes, routers[i])
        routerList.push(routerData)
      }
      this.changeRouterList(routerList)
    },
    changePage(page){
      this.currentPage=page
      this.getList()
    },
    getDate(dateString){
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();

      return {
        day,
        newDates:year+'-'+(month<10?('0'+month):month)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.notice-list {
  width: 100%;
}
</style>
